import { render, staticRenderFns } from "./asideBarItem.vue?vue&type=template&id=00ef1842&"
import script from "./asideBarItem.vue?vue&type=script&lang=js&"
export * from "./asideBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports